import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {EVENT_DETAILS} from 'src/app/app-routing.module';
import {AbstractComponent} from "@components";
import {EventItemType, EventRaceItem, Lookups, Sport} from "@model";
import {EventService} from "@services";

@Component({
  selector: 'app-event-preview',
  templateUrl: './event-preview.component.html',
  styleUrls: ['./event-preview.component.scss']
})
export class EventPreviewComponent extends AbstractComponent implements OnInit {

  @Input({required: true}) languages: Lookups[] = [];
  @Input() countries: Lookups[] = [];
  @Input() sports: Sport[] = [];
  @Input() isPreviewComponent?: boolean;

  isItemFavorite: boolean = false;
  event: EventRaceItem | undefined;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
  ) {
    super();
  }

  ngOnInit() {
    this.subscribeToRouteDataChange();
  }

  private subscribeToRouteDataChange(): void {
    this.subscriptions.push(
      this.route.data.subscribe(({isPreview, eventItem}: Data) => {
        if (eventItem) {
          this.event = eventItem;
        }
        this.isPreviewComponent = isPreview ?? false;
        this.eventService.setCurrentEvent(eventItem);
      })
    )
  }

  goToEventDetailsPage() {
    this.router.navigate([EVENT_DETAILS], {
      relativeTo: this.route,
      queryParams: {eventId: this.event?.id},
    });
  }

  protected readonly EventItemType = EventItemType;
}
